import { render } from "./GiftStat.vue?vue&type=template&id=0f3c4756"
import script from "./GiftStat.vue?vue&type=script&lang=js"
export * from "./GiftStat.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__